import React from 'react'
import { Container, Button, Form, FormGroup, Label, Input, CardText, ModalBody } from 'reactstrap'
import ButtonPrev from './ButtonPrev'
import clsx from 'clsx'

export default class BasicForm extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      isVisible: false,
      messageTouched: false,
      phoneTouched: false,
      firstNameTouched: false,
      lastNameTouched: false,
      emailTouched: false,
      addressTouched: false,
      cityTouched: false
    }
  }

  validateEmailAddress = (value) => {
    return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value)
  }

  isFormValid = () => {
    return this.state.emailValid && this.state.phoneValid && this.state.lastNameValid && this.state.messageValid && this.state.firstNameValid && this.state.addressValid && this.state.cityValid
  }

  handleNextClick = () => {
    if (!this.isFormValid()) {
      // set state to set all touched flags to true
      // this will trigger display of all error messages, because the user tried to submit, we want to display all even if they've touched the fields or not
      this.setState({
        emailTouched: true,
        phoneTouched: true,
        messageTouched: true,
        firstNameTouched: true,
        lastNameTouched: true,
        addressTouched: true,
        cityTouched: true
      })
      return
    }
    this.props.onNextClick()
  }

  openDialog = (e) => {
    e.preventDefault()
    e.stopPropagation()
    this.setState({
      isVisible: true
    })
  }

  dismissDialog = (e) => {
    e.preventDefault()
    e.stopPropagation()
    this.setState({
      isVisible: false
    })
  }

  onFirstNameInput = (e) => {
    e.preventDefault()
    e.stopPropagation()
    const firstNameTouched = true
    if (e.target.value) {
      this.setState({
        firstNameValid: true,
        firstNameTouched
      })
    } else {
      this.setState({
        firstNameValid: false,
        firstNameTouched
      })
    }
    this.props.onFirstNameInput(e)
  }

  onLastNameInput = (e) => {
    e.preventDefault()
    e.stopPropagation()
    const lastNameTouched = true
    if (e.target.value) {
      this.setState({
        lastNameValid: true,
        lastNameTouched
      })
    } else {
      this.setState({
        lastNameValid: false,
        lastNameTouched
      })
    }
    this.props.onLastNameInput(e)
  }

  onEmailInput = (e) => {
    e.preventDefault()
    e.stopPropagation()
    const emailTouched = true
    if (e.target.value && this.validateEmailAddress(e.target.value)) {
      this.setState({
        emailValid: true,
        emailTouched
      })
    } else {
      this.setState({
        emailValid: false,
        emailTouched
      })
    }
    this.props.onEmailInput(e)
  }

  onPhoneInput = (e) => {
    e.preventDefault()
    e.stopPropagation()
    const phoneTouched = true
    if (e.target.value) {
      this.setState({
        phoneValid: true,
        phoneTouched
      })
    } else {
      this.setState({
        phoneValid: false,
        phoneTouched
      })
    }
    this.props.onPhoneInput(e)
  }

  onAddressInput = (e) => {
    e.preventDefault()
    e.stopPropagation()
    const addressTouched = true
    if (e.target.value) {
      this.setState({
        addressValid: true,
        addressTouched
      })
    } else {
      this.setState({
        addressValid: false,
        addressTouched
      })
    }
    this.props.onAddressInput(e)
  }

  onZipCodeInput = (e) => {
    e.preventDefault()
    e.stopPropagation()
    const zipTouched = true
    if (e.target.value) {
      this.setState({
        zipValid: true,
        zipTouched
      })
    } else {
      this.setState({
        zipValid: false,
        zipTouched
      })
    }
    this.props.onZipCodeInput(e)
  }

  onCityInput = (e) => {
    e.preventDefault()
    e.stopPropagation()
    const cityTouched = true
    if (e.target.value) {
      this.setState({
        cityValid: true,
        cityTouched
      })
    } else {
      this.setState({
        cityValid: false,
        cityTouched
      })
    }
    this.props.onCityInput(e)
  }

  onMessageInput = (e) => {
    e.preventDefault()
    e.stopPropagation()
    const messageTouched = true
    if (e.target.value) {
      this.setState({
        messageValid: true,
        messageTouched
      })
    } else {
      this.setState({
        messageValid: false,
        messageTouched
      })
    }
    this.props.onMessageInput(e)
  }

  onWorkingWithAgentNameInput = (e) => {
    e.preventDefault()
    e.stopPropagation()

    this.props.onWorkingWithAgentNameInput(e)
  }

  render () {
    return (

      <Container className='basic-form-container'>
        <CardText>Let us get to know you better and design a personalized plan to help you and your family. Fill out the information and one of our agents will contact you. <a className='text-link text-style' href={'#'} onClick={this.openDialog}>Already working with someone?</a></CardText>
        <Form>
          <div className='d-flex flex-wrap'>
            <FormGroup className='form-width '>
              <Label className='floating-label' for='firstName'>FIRST NAME*</Label>
              <Input value={this.props.formProps.firstName} onChange={this.onFirstNameInput} type='text' name='firstName' id='formFirstName' />
              <span className={clsx('text-error', { 'hidden-error': this.state.firstNameValid || !this.state.firstNameTouched, 'visible-error': !this.state.firstNameValid })} id='formFirstName-error'>The first name field is required.</span>
            </FormGroup>
            <FormGroup className='form-width form-margin-left mt-4 mt-xl-0'>
              <Label className='floating-label' for='lastName'>LAST NAME*</Label>
              <Input value={this.props.formProps.lastName} onChange={this.onLastNameInput} type='text' name='lastName' id='formLastName' />
              <span className={clsx('text-error', { 'hidden-error': this.state.lastNameValid || !this.state.lastNameTouched, 'visible-error': !this.state.lastNameValid })} id='formLastName-error'>The last name field is required.</span>
            </FormGroup>
          </div>
          <div className='d-flex flex-wrap mt-4'>
            <FormGroup className='form-width '>
              <Label className='floating-label' for='address'>ADDRESS*</Label>
              <Input value={this.props.formProps.address} onChange={this.onAddressInput} type='text' name='address' id='formAddress' />
              <span className={clsx('text-error', { 'hidden-error': this.state.addressValid || !this.state.addressTouched, 'visible-error': !this.state.addressValid })} id='formAddress-error'>The address field is required.</span>
            </FormGroup>
            <FormGroup className='form-width form-margin-left mt-4 mt-xl-0'>
              <Label className='floating-label' for='city'>CITY*</Label>
              <Input value={this.props.formProps.city} onChange={this.onCityInput} type='text' name='city' id='formCity' />
              <span className={clsx('text-error', { 'hidden-error': this.state.cityValid || !this.state.cityTouched, 'visible-error': !this.state.cityValid })} id='formCity-error'>The city field is required.</span>
            </FormGroup>
          </div>
          <div className='d-flex flex-wrap mt-4'>
            <FormGroup className='form-width'>
              <Label className='floating-label' for='state'>STATE*</Label>
              <Input readOnly value={this.props.formProps.state} type='text' name='state' id='formState' />
            </FormGroup>
            <FormGroup className='form-width form-margin-left mt-4 mt-xl-0'>
              <Label className='floating-label' for='zip'>ZIP CODE*</Label>
              <Input readOnly value={this.props.formProps.zip} onChange={this.onZipCodeInput} type='text' name='zip' id='formZip' />
              <span className={clsx('text-error', { 'hidden-error': this.state.zipValid || !this.state.zipTouched, 'visible-error': !this.state.zipValid })} id='formZip-error'>The zip code field is required.</span>
            </FormGroup>
          </div>
          <div className='d-flex flex-wrap'>
            <FormGroup className='form-width mt-4 '>
              <Label className='floating-label' for='exampleEmail'>EMAIL*</Label>
              <Input value={this.props.formProps.emailAddress} onChange={this.onEmailInput} type='email' name='email' id='formEmail' />
              <span className={clsx('text-error', { 'hidden-error': this.state.emailValid || !this.state.emailTouched, 'visible-error': !this.state.emailValid })} id='formEmail-error'>The e-mail field is required and must be a valid e-mail.</span>
            </FormGroup>
            <FormGroup className='form-width form-margin-left mt-4'>
              <Label className='floating-label' for='phone'>PHONE*</Label>
              <Input value={this.props.formProps.phoneNo} onChange={this.onPhoneInput} type='phone' name='phone' id='formPhone' />
              <span className={clsx('text-error', { 'hidden-error': this.state.phoneValid || !this.state.phoneTouched, 'visible-error': !this.state.phoneValid })} id='formPhone-error'>The phone field is required.</span>
            </FormGroup>
          </div>

          <FormGroup className='form-margin-right mt-4'>
            <Label className='floating-label' for='exampleText'>MESSAGE*</Label>
            <Input value={this.props.formProps.emailMessage} onChange={this.onMessageInput} type='textarea' name='formMessage' id='formMessage' />
            <span className={clsx('text-error', { 'hidden-error': this.state.messageValid || !this.state.messageTouched, 'visible-error': !this.state.messageValid })} id='formMessage-error'>The message field is required.</span>
          </FormGroup>

          <div className='button-margin d-flex justify-content-between align-items-center'>
            <ButtonPrev onClick={this.props.onPrevClick} />
            <Button className='btn-submit-form' onClick={this.handleNextClick}>SUBMIT FORM</Button>
          </div>

          <div id='workingWithSomeoneDialog' className={clsx('hidden-dialog', { 'visible-dialog': this.state.isVisible })}>
            <div className='modal-header' style={{ 'padding': '9px 14px' }}>
              <h2 className='h2-sized-down'>WHO ARE YOU WORKING WITH?</h2>
              <div className='pull-right'>
                <button className='close' onClick={this.dismissDialog}>&times;</button>
              </div>
            </div>
            <ModalBody>

              <div className='form-group'>
                <input type='text' placeholder='Who are you working with?' onChange={this.onWorkingWithAgentNameInput} value={this.props.formProps.workingWithAgentName} className='form-control' id='workingWithElement' />
                <button className='btn-continue' type='button' onClick={this.dismissDialog}>Continue</button>
              </div>
            </ModalBody>
          </div>

        </Form>
      </Container>

    )
  }
}
